// src/components/customer/biddingFilters/BiddingFilters.jsx
import React, { useState } from "react";
import "../../../assets/css/customer/biddingFilters/BiddingFilters.css";

const BiddingFilters = ({ onFilterChange }) => {
  const [filters, setFilters] = useState({
    search: "",
    category: "all",
    condition: "all",
    priceRange: { min: 0, max: 1000000 },
    sortBy: "newest",
  });

  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

  const handleFilterChange = (field, value) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const handlePriceRangeChange = (min, max) => {
    const newFilters = { ...filters, priceRange: { min, max } };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const handleReset = () => {
    const resetFilters = {
      search: "",
      category: "all",
      condition: "all",
      priceRange: { min: 0, max: 1000000 },
      sortBy: "newest",
    };
    setFilters(resetFilters);
    onFilterChange(resetFilters);
  };

  return (
    <div className="bidfilter-container">
      <div className="bidfilter-main">
        {/* Search Bar */}
        <div className="bidfilter-search">
          <span className="bidfilter-search-icon">🔍</span>
          <input
            type="text"
            placeholder="Search by product name..."
            value={filters.search}
            onChange={(e) => handleFilterChange("search", e.target.value)}
            className="bidfilter-search-input"
          />
        </div>

        {/* Quick Filters */}
        <div className="bidfilter-quick">
          <select
            value={filters.category}
            onChange={(e) => handleFilterChange("category", e.target.value)}
            className="bidfilter-select"
          >
            <option value="all">All Categories</option>
            <option value="Living Room">Living Room</option>
            <option value="Bedroom">Bedroom</option>
            <option value="Dining">Dining</option>
            <option value="Office">Office</option>
            <option value="Study">Study</option>
            <option value="Outdoor">Outdoor</option>
          </select>

          <select
            value={filters.sortBy}
            onChange={(e) => handleFilterChange("sortBy", e.target.value)}
            className="bidfilter-select"
          >
            <option value="newest">Newest First</option>
            <option value="ending-soon">Ending Soon</option>
            <option value="price-low">Price: Low to High</option>
            <option value="price-high">Price: High to Low</option>
          </select>

          <button
            className="bidfilter-advanced-toggle"
            onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
          >
            {showAdvancedFilters ? "Hide" : "Show"} Filters
            <span className="bidfilter-toggle-icon">
              {showAdvancedFilters ? "▲" : "▼"}
            </span>
          </button>

          <button className="bidfilter-reset-btn" onClick={handleReset}>
            Reset
          </button>
        </div>
      </div>

      {/* Advanced Filters */}
      {showAdvancedFilters && (
        <div className="bidfilter-advanced">
          <div className="bidfilter-advanced-grid">
            {/* Condition Filter */}
            <div className="bidfilter-group">
              <label className="bidfilter-label">Condition</label>
              <div className="bidfilter-radio-group">
                <label className="bidfilter-radio">
                  <input
                    type="radio"
                    name="condition"
                    value="all"
                    checked={filters.condition === "all"}
                    onChange={(e) =>
                      handleFilterChange("condition", e.target.value)
                    }
                  />
                  <span>All</span>
                </label>
                <label className="bidfilter-radio">
                  <input
                    type="radio"
                    name="condition"
                    value="Brand New"
                    checked={filters.condition === "Brand New"}
                    onChange={(e) =>
                      handleFilterChange("condition", e.target.value)
                    }
                  />
                  <span>Brand New</span>
                </label>
                <label className="bidfilter-radio">
                  <input
                    type="radio"
                    name="condition"
                    value="Used - Like New"
                    checked={filters.condition === "Used - Like New"}
                    onChange={(e) =>
                      handleFilterChange("condition", e.target.value)
                    }
                  />
                  <span>Like New</span>
                </label>
                <label className="bidfilter-radio">
                  <input
                    type="radio"
                    name="condition"
                    value="Used - Good"
                    checked={filters.condition === "Used - Good"}
                    onChange={(e) =>
                      handleFilterChange("condition", e.target.value)
                    }
                  />
                  <span>Good</span>
                </label>
              </div>
            </div>

            {/* Price Range Filter */}
            <div className="bidfilter-group">
              <label className="bidfilter-label">Price Range (PKR)</label>
              <div className="bidfilter-price-range">
                <input
                  type="number"
                  placeholder="Min"
                  value={filters.priceRange.min}
                  onChange={(e) =>
                    handlePriceRangeChange(
                      Number(e.target.value),
                      filters.priceRange.max,
                    )
                  }
                  className="bidfilter-price-input"
                  min="0"
                />
                <span className="bidfilter-price-separator">-</span>
                <input
                  type="number"
                  placeholder="Max"
                  value={filters.priceRange.max}
                  onChange={(e) =>
                    handlePriceRangeChange(
                      filters.priceRange.min,
                      Number(e.target.value),
                    )
                  }
                  className="bidfilter-price-input"
                  min="0"
                />
              </div>
              <div className="bidfilter-price-suggestions">
                <button
                  className="bidfilter-price-tag"
                  onClick={() => handlePriceRangeChange(0, 50000)}
                >
                  Under 50k
                </button>
                <button
                  className="bidfilter-price-tag"
                  onClick={() => handlePriceRangeChange(50000, 100000)}
                >
                  50k - 100k
                </button>
                <button
                  className="bidfilter-price-tag"
                  onClick={() => handlePriceRangeChange(100000, 200000)}
                >
                  100k - 200k
                </button>
                <button
                  className="bidfilter-price-tag"
                  onClick={() => handlePriceRangeChange(200000, 1000000)}
                >
                  200k+
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BiddingFilters;
